import { Text } from "pixi.js";
import { PiggyResourcePackage } from "../../resources/PiggyResourcePackage";
import { PiggyViewTextStyle } from "../textstyle/PiggyViewTextStyle";
import { PiggyInfoComponent } from "./PiggyInfoComponent";

export class PiggyInfoNextPiggyComponent extends PiggyInfoComponent {
    private static readonly YOUR_NEXT_TEXT = 'YOUR NEXT';
    private static readonly PIGGY_HERE_TEXT = 'PIGGY HERE';

    private yourNextText: Text;
    private piggyHereText: Text;

    public constructor(piggyResources: PiggyResourcePackage) {
        super(piggyResources);
        this.yourNextText = new Text(PiggyInfoNextPiggyComponent.YOUR_NEXT_TEXT, new NextPiggyTextStyle());
        this.yourNextText.skew.x = -0.087;
        this.yourNextText.angle = -5;
        this.yourNextText.position.set(157, 276);
        this.piggyHereText = new Text(PiggyInfoNextPiggyComponent.PIGGY_HERE_TEXT, new NextPiggyTextStyle());
        this.piggyHereText.skew.x = -0.087;
        this.piggyHereText.angle = -5;
        this.piggyHereText.position.set(150, 392);
        this.addChild(this.yourNextText, this.piggyHereText);
    }
}

class NextPiggyTextStyle extends PiggyViewTextStyle {
    public constructor() {
        super();
        this.fontSize = 96;
    }
}
